import { css } from '@/styled-system/css';

export const imageStyles = css.raw({
  '&:is(img), & img': {
    display: 'block',
    maxInlineSize: '100%',
    overflow: 'clip',
  },
});
